import React, { useEffect, useState } from "react";
import PageLoader from "../loader/PageLoader";
import { ChatText, CurrencyInr, WarningCircle, X } from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import dayjs from "dayjs";
import { RejectHotel } from "./RejectAPI";
import { toast } from "react-toastify";
import PromoBreakdown from "./PromoBreakdown";

const ExtendStay = ({ func, selectedRequest }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [remarks, setRemarks] = useState("");
    const [remarksError, setRemarksError] = useState(false);

    const [newRooms, setNewRooms] = useState([]);
    const [amount, setAmount] = useState("");
    const [selectedNewRoom, setSelectedNewRoom] = useState("");

    // Fetch Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setErrors("");
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/extend-stay-request`,
                    { params: { guest_request_id: selectedRequest.requestId } },
                );
                const roomResponse = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/rooms`,
                );

                let price = (response.data && response.data.total_amount!=null && response.data.total_amount!=undefined) ? response.data.total_amount.toString() : "";
                setAmount(price);
                setData(response.data);
                setRemarks(response.data?.remarks || "");
                const newRoom = response.data?.new_room;
                if (newRoom) {
                    setSelectedNewRoom(newRoom); // Set to new_room if it exists
                } else {
                    setSelectedNewRoom(response.data?.service_room);
                }
                setNewRooms(roomResponse.data?.data || []);
                setLoading(false);
            } catch (err) {
                setErrors({ fetch: "Failed to fetch Extend Room data" });
                setLoading(false);
            }
        };
        fetchData();
    }, [selectedRequest]);

    // Reject Request
    const handleRejectRequest = async () => {
        try {
            if(remarks.trim()==="") {
                setRemarksError(true);
                return;
            }
            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: data?.guest_request_id,
            };
            await RejectHotel(request,remarks);
            func(false);
        } catch (error) {
            setErrors({ reject: "Failed to reject the Extend room request" });
            console.error(error);
        }
    };

    // Respond to Guest
    const handleRespondToGuest = async () => {
        try {
            if (!selectedNewRoom || !amount) {
                setErrors({ staff: "Room number and amount are required" });
                return;
            }

            setErrors({ fetch: "" });

            await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/extend-stay-request/${data?.id}`,
                {
                    is_declined: false,
                    remarks: remarks,
                    price: parseFloat(amount),
                    new_room: parseInt(selectedNewRoom),
                },
            );
            func(false);
        } catch (error) {
            setErrors({ fetch: "Failed to update Extend Room request" });
            console.error(error);
        }
    };


 
    // Complete Hotel
    const handleCompleteHotel = async()=>{
        try{
            setErrors({ fetch: "" });
            const passData = {
                is_approved : true,
                price : parseFloat(amount),
                remarks : remarks,
                new_room : parseInt(selectedNewRoom),
            }
            await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/extend-stay-request/${data?.id}`,passData);
            toast.success("Extend Stay Request Completed");
            func(false);
        }catch(error){
            console.log(error)
            toast.error(error?.response?.data?.message || "Some Error Occured")
        }
    }
    

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            {loading && <PageLoader />}
            <form
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                onSubmit={(e) => e.preventDefault()}
            >
                {/* Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Extend Stay</h2>
                    <button
                        onClick={() => func(false)}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                {/* Room Number Details */}
                <div className="flex items-center justify-between gap-2 mb-1">
                    <div className="w-1/2">
                        <p className="text-[#8C9199] mb-2">Room Number</p>
                        <p className="pr-4">{data?.service_room || ""}</p>
                    </div>
                    <div className="w-1/2">
                        <p className="text-[#8C9199] mb-2">No. of Nights</p>
                        <p>{data?.number_of_nights}</p>
                    </div>
                </div>

                {/*  Note */}
                <div>
                    <p className="mb-1 text-[#8C9199]">Note</p>
                    <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 text-sm">
                        <ChatText size={16} weight="bold" />{" "}
                        {data?.additional_comments || ""}
                    </p>
                </div>

                <div className="flex items-center gap-4">

                    {/* Room Number */}
                    <div className="w-1/2">
                        <p className="mb-1 text-[#8C9199]">Room Number</p>
                        <select
                            name="conference_room"
                            id="conference_room"
                            className="border-[1.5px] rounded-md p-1.5 w-full"
                            onChange={(e) => setSelectedNewRoom(e.target.value)}
                            disabled={true}
                            value={selectedNewRoom}
                        >
                            <option value="">Select Room Number</option>
                            {newRooms.map((room) => (
                                <option key={room.id} value={room.number}>
                                    Room {room.number} - Capacity:{" "}
                                    {room.capacity}
                                </option>
                            ))}
                        </select>
                    </div>
                    
                    {/* Fee Data */}
                    <div className="w-1/2">
                        <p className="mb-1 text-[#8C9199]">
                            Quote Fee for Stay Extension
                        </p>
                        <div className="border-[1.5px] rounded-md p-1.5 w-full flex items-center gap-2">
                            <CurrencyInr />
                            <input
                                type="text"
                                placeholder="Enter your fee"
                                className="outline-none border-none w-full"
                                value={amount}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (!isNaN(value) && value >= 0) {
                                        setAmount(value);
                                    }
                                    setErrors("");
                                }}
                                disabled={data?.status=="InProgress_Hotel" || data?.status==="Scheduled_Hotel"}
                            />
                        </div>
                    </div>
                </div>
                {errors.staff && (
                    <p className="text-[#ff7378] text-[12px] flex items-center gap-1 p-0.5 -mt-2">
                        <WarningCircle />
                        {errors.staff}
                    </p>
                )}

                <PromoBreakdown
                    grossAmount={data?.total_amount}
                    discountAmount={data?.discount_amount}
                    promotionId={data?.promotion_id}
                />

                <div>
                    <p className="text-[#8C9199] mb-1">Remarks</p>
                    <textarea
                        rows={4}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
                        placeholder="Mention your comment here"
                        value={remarks}
                        onChange={(e)=>{
                            const value = e.target.value;
                            setRemarks(value);
                            setRemarksError(false);
                        }}
                    ></textarea>
                    {remarksError && (
                        <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                            <WarningCircle size={14} />
                            remarks is required when you reject the request
                        </p>
                    )}
                </div>

                <div className="flex flex-wrap gap-3 mt-2">
                    <button
                        className="p-2 flex-1 border-[1.5px] border-red-300 text-[#ff7378] rounded-md font-medium hover:bg-red-50 transition duration-150 outline-none"
                        type="button"
                        onClick={handleRejectRequest}
                    >
                        Reject Request
                    </button>
                    <button
                        className="p-2 flex-1 l bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150 outline-none"
                        type="button"
                        onClick={handleRespondToGuest}
                    >
                        Respond To Guest
                    </button>

                    {data && data.status &&
                        (data.status==="InProgress_Hotel" || data.status==="Scheduled_Hotel") && <button
                            className="p-2 flex-1  border-[1.5px] bg-[#73c9ff] rounded-md font-medium hover:bg-[#5fa4f7] transition duration-150 outline-none"
                            type="button"
                            onClick={()=>handleCompleteHotel()}
                        >
                        Complete Request
                        </button>
                    }


                </div>

                {errors.fetch && <p className="text-red-500">{errors.fetch}</p>}
                {errors.reject && (
                    <p className="text-red-500">{errors.reject}</p>
                )}
            </form>
        </div>
    );
};

export default ExtendStay;
